import { createRouter, createWebHashHistory } from 'vue-router'
import { LOGIN_TOKEN } from '@/global/constants'
import { localCache } from '@/utils/cache'

const router = createRouter({
  history: createWebHashHistory(),
  // 映射关系: path -> component
  routes: [
    {
      path: '/',
      redirect: '/user'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index.vue')
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('@/views/user/index.vue')
    },
    {
      path: '/change',
      name: 'change',
      component: () => import('@/views/change/index.vue')
    },
    {
      path: '/down',
      name: 'down',
      component: () => import('@/views/down/index.vue')
    },
    {
      path: '/notice',
      name: 'notice',
      component: () => import('@/views/notice/index.vue')
    },
    {
      path: '/travelPassenger',
      name: 'travelPassenger',
      component: () => import('@/views/travel/passenger/index.vue')
    },
    {
      path: '/travelBuy',
      name: 'travelBuy',
      component: () => import('@/views/travel/travelBuy/index.vue')
    },
    {
      path: '/manage',
      name: 'manage',
      component: () => import('@/views/manage/index.vue')
    },
    {
      path: '/manageShip',
      name: 'manageShip',
      component: () => import('@/views/manage/manageShip/index.vue')
    },
    {
      path: '/manageStar',
      name: 'manageStar',
      component: () => import('@/views/manage/manageStar/index.vue')
    },
    {
      path: '/manageCover',
      name: 'manageCover',
      component: () => import('@/views/manage/manageCover/index.vue')
    },
    {
      path: '/travelPaymentShip',
      name: 'travelPaymentShip',
      component: () => import('@/views/travel/travelPaymentShip/index.vue')
    },
    {
      path: '/travelPaymentCover',
      name: 'travelPaymentCover',
      component: () => import('@/views/travel/travelPaymentCover/index.vue')
    },
    {
      path: '/starPayment',
      name: 'starPayment',
      component: () => import('@/views/star/payment/index.vue')
    },
    {
      path: '/starPassenger',
      name: 'starPassenger',
      component: () => import('@/views/star/passenger/index.vue')
    },
    // {
    //   path: '/starBuy',
    //   name: 'starBuy',
    //   component: () => import('@/views/star/buy/index.vue')
    // },
    {
      path: '/:pathMatch(.*)',
      component: () => import('../views/notFound/index.vue')
    }
  ]
})
router.beforeEach((to) => {
  // 只有登录成功(token), 才能真正进入到user页面
  const token = localCache.getCache(LOGIN_TOKEN)
  if (to.path.startsWith('/user') && !token) {
    return '/login'
  }
})
export default router
